import set from 'lodash/set';

import utils from '../../../lib/utils';

export default {
  salesYearLocaleCurrency: ({ salesYear }) => salesYear.filter(({ _id }) => _id.currency === 'MXN'),
  salesYearTotal: (state, { salesYearLocaleCurrency: salesYear }) => (
    salesYear.reduce((accum, { totalAmount }) => accum + totalAmount, 0)
  ),
  salesYearTotalCurrency: (state, { salesYearTotal }) => utils.toCurrency(salesYearTotal, 'MXN'),
  salesYearLabels: (state, { salesYearLocaleCurrency: salesYear }) => (
    salesYear.map(({ _id }) => `${_id.year}-${_id.month}`)
  ),
  salesYearSeries: (state, { salesYearLocaleCurrency: salesYear }) => (
    salesYear.map(({ totalAmount }) => totalAmount)
  ),
  salesMonthLocaleCurrency: ({ salesMonth }) => salesMonth.filter(({ _id }) => _id.currency === 'MXN'),
  salesMonthTotal: (state, { salesMonthLocaleCurrency: salesMonth }) => (
    salesMonth.reduce((accum, { totalAmount }) => accum + totalAmount, 0)
  ),
  salesMonthTotalCurrency: (state, { salesMonthTotal }) => utils.toCurrency(salesMonthTotal, 'MXN'),
  salesMonthLabels: (state, { salesMonthLocaleCurrency: salesMonth }) => (
    salesMonth.map(({ _id }) => `${_id.year}-${_id.month}-${_id.day}`)
  ),
  salesMonthSeries: (state, { salesMonthLocaleCurrency: salesMonth }) => (
    salesMonth.map(({ totalAmount }) => totalAmount)
  ),
  salesDayLocaleCurrency: ({ salesDay }) => salesDay.filter(({ _id }) => _id.currency === 'MXN'),
  salesDayTotal: (state, { salesDayLocaleCurrency: salesDay }) => (
    salesDay.reduce((accum, { totalAmount }) => accum + totalAmount, 0)
  ),
  salesDayTotalCurrency: (state, { salesDayTotal }) => utils.toCurrency(salesDayTotal, 'MXN'),
  salesDayLabels: (state, { salesDayLocaleCurrency: salesDay }) => (
    salesDay.map(({ _id }) => `${_id.year}-${_id.month}-${_id.day}T${_id.hour}:00:00`)
  ),
  salesDaySeries: (state, { salesDayLocaleCurrency: salesDay }) => (
    salesDay.map(({ totalAmount }) => totalAmount)
  ),
  salesItemsLabels: ({ salesItems }) => salesItems.map(({ date }) => date),
  salesItemsSeries({ salesItems }, { salesItemsLabels }) {
    const dates = salesItemsLabels;

    const plainItems = [];

    const uniqueItems = salesItems.reduce((accum, { items }) => {
      plainItems.push(...items);

      const uniques = items.filter(({ item }) => !accum.includes(item));

      return accum.concat(uniques.map(({ item }) => item));
    }, []);

    const series = uniqueItems.reduce((accum, name) => {
      accum.push({ name, data: new Array(dates.length).fill(0) });

      return accum;
    }, []);

    plainItems.forEach(({ date, item, count }) => {
      const itemIndex = series.findIndex(({ name }) => name === item);
      const dateIndex = dates.indexOf(date);

      set(series, `${itemIndex}.data.${dateIndex}`, count);
    });

    return series;
  },
  salesItemsAllLabels: ({ salesItemsAll }) => (
    salesItemsAll.map(({ _id: id }) => `${id.sku}-${id.description}`)
  ),
  salesItemsAllSeries: ({ salesItemsAll }) => (
    salesItemsAll.map(({ count }) => count)
  ),

  salesYearLocaleCurrencyNonFiscal: ({ salesYearNonFiscal }) => salesYearNonFiscal.filter(({ _id }) => _id.currency === 'MXN'),
  salesYearTotalNonFiscal: (state, { salesYearLocaleCurrencyNonFiscal }) => (
    salesYearLocaleCurrencyNonFiscal.reduce((accum, { totalAmount }) => accum + totalAmount, 0)
  ),
  salesYearTotalCurrencyNonFiscal: (state, { salesYearTotalNonFiscal }) => utils.toCurrency(salesYearTotalNonFiscal, 'MXN'),
  salesYearLabelsNonFiscal: (state, { salesYearLocaleCurrencyNonFiscal }) => (
    salesYearLocaleCurrencyNonFiscal.map(({ _id }) => `${_id.year}-${_id.month}`)
  ),
  salesYearSeriesNonFiscal: (state, { salesYearLocaleCurrencyNonFiscal }) => (
    salesYearLocaleCurrencyNonFiscal.map(({ totalAmount }) => totalAmount)
  ),
  salesMonthLocaleCurrencyNonFiscal: ({ salesMonthNonFiscal }) => salesMonthNonFiscal.filter(({ _id }) => _id.currency === 'MXN'),
  salesMonthTotalNonFiscal: (state, { salesMonthLocaleCurrencyNonFiscal }) => (
    salesMonthLocaleCurrencyNonFiscal.reduce((accum, { totalAmount }) => accum + totalAmount, 0)
  ),
  salesMonthTotalCurrencyNonFiscal: (state, { salesMonthTotalNonFiscal }) => utils.toCurrency(salesMonthTotalNonFiscal, 'MXN'),
  salesMonthLabelsNonFiscal: (state, { salesMonthLocaleCurrencyNonFiscal }) => (
    salesMonthLocaleCurrencyNonFiscal.map(({ _id }) => `${_id.year}-${_id.month}-${_id.day}`)
  ),
  salesMonthSeriesNonFiscal: (state, { salesMonthLocaleCurrencyNonFiscal }) => (
    salesMonthLocaleCurrencyNonFiscal.map(({ totalAmount }) => totalAmount)
  ),
  salesDayLocaleCurrencyNonFiscal: ({ salesDayNonFiscal }) => salesDayNonFiscal.filter(({ _id }) => _id.currency === 'MXN'),
  salesDayTotalNonFiscal: (state, { salesDayLocaleCurrencyNonFiscal }) => (
    salesDayLocaleCurrencyNonFiscal.reduce((accum, { totalAmount }) => accum + totalAmount, 0)
  ),
  salesDayTotalCurrencyNonFiscal: (state, { salesDayTotalNonFiscal }) => utils.toCurrency(salesDayTotalNonFiscal, 'MXN'),
  salesDayLabelsNonFiscal: (state, { salesDayLocaleCurrencyNonFiscal }) => (
    salesDayLocaleCurrencyNonFiscal.map(({ _id }) => `${_id.year}-${_id.month}-${_id.day}T${_id.hour}:00:00`)
  ),
  salesDaySeriesNonFiscal: (state, { salesDayLocaleCurrencyNonFiscal }) => (
    salesDayLocaleCurrencyNonFiscal.map(({ totalAmount }) => totalAmount)
  ),

  sumSalesYearTotal: (state, { salesYearTotal, salesYearTotalNonFiscal }) => (
    salesYearTotal + salesYearTotalNonFiscal
  ),
  sumSalesYearTotalCurrency: (state, { sumSalesYearTotal }) => (
    utils.toCurrency(sumSalesYearTotal, 'MXN')
  ),
  sumSalesMonthTotal: (state, { salesMonthTotal, salesMonthTotalNonFiscal }) => (
    salesMonthTotal + salesMonthTotalNonFiscal
  ),
  sumSalesMonthTotalCurrency: (state, { sumSalesMonthTotal }) => (
    utils.toCurrency(sumSalesMonthTotal, 'MXN')
  ),
  sumSalesDayTotal: (state, { salesDayTotal, salesDayTotalNonFiscal }) => (
    salesDayTotal + salesDayTotalNonFiscal
  ),
  sumSalesDayTotalCurrency: (state, { sumSalesDayTotal }) => (
    utils.toCurrency(sumSalesDayTotal, 'MXN')
  ),
  emptyStatistics({ salesAll, salesYearNonFiscal }) {
    return salesAll.length === 0 && salesYearNonFiscal.length === 0;
  },
};
